import { MissingDefinition, SerializedWidget, Widget } from './Widget'

/**
 * A collection of collection functions for arrays of widgets, serializedWidgets, and layouts.
 * These functions are designed to be used with built in JS collection functions, such as map, filter, etc.
 */

/**
 * Find a widget definition match for a serialized widget.  Usage
 * const finder = findWidget(widgetTypes)
 * const matchingDef = finder(serial)
 * @param widgetTypes
 * @returns {function(*=): Widget}
 */
const findWidget = (widgetTypes) => {
  return serialWidget => {
    let w = widgetTypes.find(def => def.matchesSerialized(serialWidget))
      || MissingDefinition(serialWidget.name || "unknown");
    return new Widget(serialWidget.id, w)
  }
};

const findDefinition = name => widgets => {
  return widgets.find(d => d.name === name) || MissingDefinition("unknown");
}

/**
 * Matches a layout entry to a serialized widget.
 * @param {array} serializedWidgets
 */
const findSerialForLayout = serializedWidgets => ({i}) => {
  return serializedWidgets.find(s => s.id === i) || new SerializedWidget("Invalid", "Invalid")
}

export {  findWidget, findSerialForLayout, findDefinition }
